import React, { Component } from "react";
import { AlertModal } from "../AlertModal/AlertModal";
import './ModalInstrucoes.css';

export const ModalIntrucoesAmbiente =

class extends Component {
	render() {
		return <AlertModal
          titulo={this.props.titulo}
		      visible={this.props.visible}
          handleClose={this.props.handleClose}
          width={600}
        >
          <div className="container-body">
            <p>Solicite liberação de IPs para acessar o ambiente de Homologação somente se for acessar APIs que estejam nesse ambiente.</p>
            <p>Para identificar se a API está no ambiente é necessário verificar se o endpoint de geração de token e da API são os seguintes:</p>
            <p>Token:<br/>https://h-apigateway.conectagov.np.estaleiro.serpro.gov.br/oauth2/jwt-token</p>
            <p>URL Base de todas as APIs:<br/>https://h-apigateway.conectagov.np.estaleiro.serpro.gov.br/</p>
            <p>As APIs de Homologação que o próprio gestor do órgão faz a geração de credencial são gerenciadas pelo API Gateway de Produção. Para acessar essas APIs é necessário solicitar liberação de IP somente para o ambiente de Produção</p>
            <p>Mais informações podem ser obtidas através da Funcionalidade Informações Técnicas da Plataforma de Interoperabilidade clicando no botão Orientações Gerais e consultando a API que será usada em Produção. No detalhamento da API tem todos os endpoints .</p>
          </div>
        </AlertModal>
	}

}